import content from "./jsonParsers/content.json";

const SocialSet = {
  share: content.Socials.share,
  twitter: content.Socials.twitter,
  emailSubject: content.Socials.emailSubject,
  emailBody: content.Socials.emailBody,
};

export default SocialSet;
